export const accountConstants = {
  GET_NICK_NAME_STORES_REQUEST: 'ACCOUNT/GET_NICK_NAME_STORES_REQUEST',
  GET_NICK_NAME_STORES_SUCCESS: 'ACCOUNT/GET_NICK_NAME_STORES_SUCCESS',
  GET_NICK_NAME_STORES_FAILED: 'ACCOUNT/GET_NICK_NAME_STORES_FAILED',
  GET_TOP_SOLD_STORES_REQUEST: 'ACCOUNT/GET_TOP_SOLD_STORES_REQUEST',
  GET_TOP_SOLD_STORES_SUCCESS: 'ACCOUNT/GET_TOP_SOLD_STORES_SUCCESS',
  GET_TOP_SOLD_STORES_FAILED: 'ACCOUNT/GET_TOP_SOLD_STORES_FAILED',
  GET_TOP_SOLD_SKU_REQUEST: 'ACCOUNT/GET_TOP_SOLD_SKU_REQUEST',
  GET_TOP_SOLD_SKU_SUCCESS: 'ACCOUNT/GET_TOP_SOLD_SKU_SUCCESS',
  GET_TOP_SOLD_SKU_FAILED: 'ACCOUNT/GET_TOP_SOLD_SKU_FAILED',
  UPDATE_SELECTED_STORE: 'ACCOUNT/UPDATE_SELECTED_STORE',
  GET_LINKED_WAREHOUSE_REQUEST: 'ACCOUNT/GET_LINKED_WAREHOUSE_REQUEST',
  GET_LINKED_WAREHOUSE_SUCCESS: 'ACCOUNT/GET_LINKED_WAREHOUSE_SUCCESS',
  GET_LINKED_WAREHOUSE_FAILED: 'ACCOUNT/GET_LINKED_WAREHOUSE_FAILED',
  STORE_GROUP: 'ACCOUNT/STORE_GROUP',
  UPDATE_SELECTED_TABLE_COLUMNS: 'ACCOUNT/UPDATE_SELECTED_TABLE_COLUMNS',
  GET_CALENDAR_EVENTS_REQUEST: 'ACCOUNT/GET_CALENDAR_EVENTS_REQUEST',
  GET_CALENDAR_EVENTS_SUCESSS: 'ACCOUNT/GET_CALENDAR_EVENTS_SUCESSS',
  GET_CALENDAR_EVENTS_FAILED: 'ACCOUNT/GET_CALENDAR_EVENTS_FAILED',
  UPDATE_ACCOUNT_ACCESS_TYPE: 'ACCOUNT/UPDATE_ACCOUNT_ACCESS_TYPE',

  SET_IS_DEMO_HOST: 'account/SET_IS_DEMO_HOST'
};
